module.exports = __webpack_public_path__ + "static/media/linkedin-brands-solid-full.c3e9f73f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/linkedin-brands-solid-full.svg
// module id = 230
// module chunks = 0